import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Imagecarousl from "../../Images/Imagecarousl.png";
import Imagec3 from "../../Images/Imagec3.png";

export default function MPBlock2() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentSlide, setCurrentSlide] = useState(0);
  const history = useHistory();

  // Example carousel data - replace with real data later
  const carouselItems = [
    {
      id: 1,
      image: Imagecarousl,
      phoneNumber: "501234567",
      countryNumber: "+972",
    },
    {
      id: 2,
      image: Imagec3,
      phoneNumber: "790205074",
      countryNumber: "+46",
    },
    // {
    //   id: 3,
    //   image: "https://picsum.photos/1200/300?random=3",
    //   phoneNumber: "542063955",
    //   countryNumber: "+972",
    // },
  ];

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-advance carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [carouselItems.length]);

  const handleSlideClick = (phoneNumber, countryNumber) => {
    history.push(`/barber-main-page/${phoneNumber}`);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + carouselItems.length) % carouselItems.length,
    );
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        paddingBottom: 20,
      }}
    >
      <div
        style={{
          width: "90%",
          backgroundColor: "#06b6d4",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          height: windowWidth <= 1024 ? "150px" : "300px",
          marginTop: 20,
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Carousel slides */}
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
          }}
        >
          {carouselItems.map((item, index) => (
            <div
              key={item.id}
              onClick={() => {
                //handleSlideClick(item.phoneNumber, item.countryNumber)
              }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: currentSlide === index ? 1 : 0,
                transition: "opacity 0.5s ease-in-out",
                cursor: "pointer",
                pointerEvents: currentSlide === index ? "auto" : "none",
              }}
            >
              <img
                src={item.image}
                alt={`Ad ${index + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
                onError={(e) => {
                  e.target.src = `https://via.placeholder.com/1200x300/${
                    ["FF6B6B", "4ECDC4", "45B7D1"][index]
                  }/FFFFFF?text=Barber+Ad+${index + 1}`;
                }}
              />
            </div>
          ))}
        </div>

        {/* Previous button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            prevSlide();
          }}
          style={{
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            fontSize: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
            fontWeight: "bold",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.7)";
          }}
        >
          ‹
        </button>

        {/* Next button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            nextSlide();
          }}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            fontSize: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
            fontWeight: "bold",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.7)";
          }}
        >
          ›
        </button>

        {/* Dots indicator */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: "8px",
            zIndex: 10,
          }}
        >
          {carouselItems.map((_, index) => (
            <button
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                goToSlide(index);
              }}
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                border: "2px solid white",
                backgroundColor:
                  currentSlide === index ? "white" : "transparent",
                cursor: "pointer",
                padding: 0,
                transition: "background-color 0.3s ease",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
